import React, { useState, useEffect, useCallback } from "react";
import moment from "moment";
import { connect } from "react-redux";
import { Button, Modal, Pagination } from "antd";

import TransfersFilters from "../TransfersFilters";
import { getTransfers } from "../../actions/transfers";
import DownloadTransferOrder from "./../../../../components/downloadTransferOrder/DownloadTransferOrder";
import { validateTransferOrderProvider, rejectTransferOrderProvider } from "../../../../lib/api/providers";
import DownloadExportCompta from "../../../../components/downloadTransferOrder/DownloadExportCompta";
import DownloadExportBanque from "../../../../components/downloadTransferOrder/DownloadExportBanque";
import { SERVICES } from "../../../../configs/constants";
import AuthRender from "../../../../containers/AuthRender";
import { handleError } from "../../api/api";

const columns = ["N°", "Entreprise", "Date de création", "Date d'exécution", "Montant", "Statut", "Actions"];
const validateBank = async (filters = {}, token) => {
  await validateTransferOrderProvider.post(
    "/",
    { ...filters },
    {
      responseType: "arraybuffer",
      headers: {
        Authorization: token
      }
    }
  );
};

const refuseBank = async (filters = {}, token) => {
  await rejectTransferOrderProvider.post(
    "/",
    { ...filters },
    {
      responseType: "arraybuffer",
      headers: {
        Authorization: token
      }
    }
  );
};
const ValidationButton = ({ transferId, token, requestFetchTransfers }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <span className="mx-5">
      <Modal
        title="Confirmation de la validation par la banque ? "
        visible={isVisible}
        onOk={async () => {
          setIsLoading(true);
          try {
            await validateBank({ transfer_id: transferId }, token);
            await requestFetchTransfers();
          } catch (e) {
            handleError(e);
          }
          setIsLoading(false);
          setIsVisible(false);
        }}
        onCancel={() => setIsVisible(false)}
        confirmLoading={isLoading}
      >
        <p>Confirmation du succés de l'émission du virement</p>
      </Modal>
      <Button
        onClick={() => {
          setIsVisible(true);
        }}
        style={{ background: "#52c41a" }}
      >
        Valider banque
      </Button>
    </span>
  );
};
const RefuseButton = ({ transferId, token, requestFetchTransfers }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <span className="mx-5">
      <Modal
        title="Confirmation du rejet par la banque ? "
        visible={isVisible}
        onOk={async () => {
          setIsLoading(true);
          try {
            await refuseBank({ transfer_id: transferId }, token);
            await requestFetchTransfers();
          } catch (e) {
            handleError(e);
          }
          setIsLoading(false);
          setIsVisible(false);
        }}
        onCancel={() => setIsVisible(false)}
        confirmLoading={isLoading}
      >
        <p>Confirmation du rejet de l'émission du virement</p>
      </Modal>
      <Button
        onClick={() => {
          setIsVisible(true);
        }}
        style={{ background: "#f5222d", marginTop: 10 }}
      >
        Refuser banque
      </Button>
    </span>
  );
};
const TransfersBank = ({ getTransfers, transfersList = [], token, userRoleId }) => {
  const [selectedDate, setSelectedDate] = useState();
  const [selectedBankStatus, setSelectedBankStatus] = useState();
  const [selectedCompanyLabel, setSelectedCompanyLabel] = useState();
  const [selectedTransferId, setSelectedTransferId] = useState();
  const [currentPage, setCurrentPage] = useState(1);

  const getRequestParams = () => {
    const filters = {
      match: {},
      page: 1
    };

    if (selectedBankStatus) filters.match["status.label"] = selectedBankStatus;
    if (selectedCompanyLabel) filters.match["company_label"] = selectedCompanyLabel;
    if (selectedTransferId) filters.match["id"] = selectedTransferId;
    if (selectedDate) {
      filters.match["updated_at"] = {
        $gte: { $date: moment(selectedDate).startOf("day") },
        $lte: { $date: moment(selectedDate).endOf("day") }
      };
    }
    return filters;
  };

  const requestFetchTransfers = useCallback(
    (
      params = {
        match: {},
        page: 1
      }
    ) => {
      getTransfers(params);
    },
    [getTransfers]
  );

  useEffect(() => {
    requestFetchTransfers();
  }, []);

  useEffect(() => {
    requestFetchTransfers({
      ...getRequestParams()
    });
  }, [selectedCompanyLabel, selectedBankStatus, selectedTransferId, selectedDate]);

  const getTableData = transfersList ? transfersList.docs : [];

  const getStatusStyle = statusId => {
    if (statusId === 1) return "text-gray-400";
    else if (statusId === 2) return "text-green-400";
    return "text-red-500";
  };

  const onChangeListPage = value => {
    setCurrentPage(value);
    requestFetchTransfers({
      page: value,
      match: {
        ...getRequestParams().match
      }
    });
  };

  return (
    <div>
      <TransfersFilters
        token={token}
        userRoleId={userRoleId}
        dateSelected={selectedDate}
        setSelectedDate={setSelectedDate}
        setSelectedBankStatus={setSelectedBankStatus}
        selectedBankStatus={selectedBankStatus}
        selectedCompanyLabel={selectedCompanyLabel}
        setSelectedCompanyLabel={setSelectedCompanyLabel}
        selectedTransferId={selectedTransferId}
        setSelectedTransferId={setSelectedTransferId}
        data={getTableData}
        menuItem="bank"
      />
      <table className="min-w-full">
        <thead>
          <tr>
            {columns.map(columnTitle => (
              <th
                index={columnTitle}
                className="px-6 py-3 border-b border-gray-200 text-left leading-4 font-medium text-gray-800 tracking-wider"
              >
                {columnTitle}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white">
          {transfersList &&
            transfersList.docs &&
            getTableData.map(dataItem => {
              return (
                <tr className="hover:bg-gray-100 cursor-pointer">
                  <td className="p-6 whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-gray-900">
                    {dataItem.id}
                  </td>
                  <td className="p-6 whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-gray-900">
                    {dataItem.company_label}
                  </td>
                  <td className="p-6 whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-gray-900">
                    {moment(dataItem.created_at).format("DD/MM/YYYY")}
                  </td>
                  <td className="p-6 whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-gray-900">
                    {dataItem.status.id !== 1 && moment(dataItem.updated_at).format("DD/MM/YYYY")}
                  </td>
                  <td className="p-6 whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-gray-900">
                    {dataItem.amount && Number.parseFloat(dataItem.amount).toFixed(2)} €
                  </td>
                  <td className="p-6 whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-gray-900">
                    {dataItem.status && (
                      <div className={`font-bold ${getStatusStyle(dataItem.status.id)}`}>{dataItem.status.label}</div>
                    )}
                  </td>
                  <td className="p-6 whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-gray-900">
                    <AuthRender service={SERVICES.Virement} access={["export"]}>
                      <DownloadTransferOrder token={token} transferOrderId={dataItem._id} />
                      <DownloadExportCompta token={token} transferOrderId={dataItem._id} />
                      <DownloadExportBanque token={token} transferOrderId={dataItem._id} />
                      {dataItem.status && dataItem.status.id === 1 && (
                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                          <ValidationButton
                            transferId={dataItem._id}
                            token={token}
                            requestFetchTransfers={requestFetchTransfers}
                          />
                          <RefuseButton
                            transferId={dataItem._id}
                            token={token}
                            requestFetchTransfers={requestFetchTransfers}
                          />
                        </div>
                      )}
                    </AuthRender>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
      {transfersList && (
        <div className="flex justify-end mt-8">
          <Pagination defaultCurrent={transfersList.page} total={transfersList.total} onChange={onChangeListPage} />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    token: state.auth.token,
    userRoleId: state.userInfos.role_id,
    transfersList: state.transfers.transfersList
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getTransfers: payload => {
      dispatch(getTransfers(payload));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TransfersBank);



// WEBPACK FOOTER //
// src/modules/presence/transfers/transfersBank/TransfersBank.js